export const STORE = '//store.wps.cn';

export const PLUSSVR = '//plussvr.wps.cn';

export const PLUS = '//plus.wps.cn';

// 加载企业平台sdk
export const loadEpSdk = () => new Promise((resolve, reject) => {
  if (window.epPlatform) {
      resolve(window.epPlatform)
      return
  }
  const s = document.createElement('script')
  s.src = `${PLUS}/fab/sdk/v1/epplatform`;
  s.onload = () => { resolve(window.epPlatform) }; s.onerror = reject
  document.head.appendChild(s)
})





const getCompanyName = (companyid, userid, list) => {
  const targetCompany = list?.find(item => item.company_id === companyid && item.userid === userid);
  return targetCompany?.company_name || '';
};

// 进入企业
const onJumpCompany = (params) => {
  const { currentUserid, targetUserid, targetCompanyid, companyName } =
  params || {};
  // 是否为不同账号状态
  const isSameUser = currentUserid === targetUserid;
  window?.epPlatform?.jumpCompany({
    companyid: targetCompanyid,
    userid: targetUserid,
    companyname: companyName,
    isSameUser,
  });
};

// 加入企业数量超限
export const renderModalCompanyLimit = async (options) => {
  let role = ''; // 当前用户角色
  const { userid, companyid, closed = () => {} } = options || {};
  return window?.epPlatform?.renderModalCompanyLimit({
    userid,
    companyid,
    legacy: true, // 是否兼容旧企业
    title: '加入企业数量超限 ',
    maskClose: false,
    closed,
    onReady: (val) => {
      role = val?.currentAccount?.role_id;
    },
    onClick: async (info) => {
      setTimeout(() => {
        onJumpCompany({
          currentUserid: userid,
          targetUserid: info.userid,
          targetCompanyid: info?.companyid,
          companyName: info.company_name
        });
      }, 300);
    }
  });
};

// 多账号引导
export const openRegisterMultiAccountGuide = async (options) => {
  let result = false;
  await loadEpSdk().then(async () => {
    const { companyid, userid, onSwitchSuccess, closed = false } = options || {};
    try {
      const [switchStatus = false, multiAccountApi, limitStatus] = await Promise.all([
        window?.epPlatform?.getMultiAccountSwitch(companyid),
        window?.epPlatform?.getMultiAccountApi(),
        renderModalCompanyLimit({ userid, companyid, closed }),
      ]);

      // 多账号开关流程且已经未超过企业关联限制
      if(switchStatus && !limitStatus) {
        let role = ''; // 当前用户角色
        let switchAccountLoadingDialog;
        const [personalAccountList, list] = await Promise.all([
          multiAccountApi.getPersonalAccount(),
          multiAccountApi.getCompanyAccounts(),
        ]);
        const personal = personalAccountList?.length;
        const companyName = getCompanyName(companyid, userid, list);
        const strongText = `<strong>「${companyName}」</strong>`;
        const content = `当前登录账号已加入${strongText}，${ personal ? '是否切换个人账号继续创建新企业？' : '企业账号不支持再创建新企业。'}`;
        window?.epPlatform?.showMultiAccountGuide({
          title: '企业账号不支持创建新企业',
          content,
          listTip: '切换账号并创建新企业',
          closed,
          personal: !!personal, // 指定切换到个人账号
          selectText: !personal && '进入企业',
          canJump: true,
          cbUrl: location.href,
          disableUsing: true,
          companyid: !personal ? companyid : undefined,
          strict: true,
          listType: 'account',
          onReady: (val) => {
            role = val?.currentAccount?.role_id;
          },
          switchHandler: async (info) => {
            const operation = personal ? 'switch' : 'click';
            if (!personal) {
              setTimeout(() => {
                onJumpCompany({
                  currentUserid: userid,
                  targetUserid: info.userid,
                  targetCompanyid: info?.company_id,
                  companyName: info.company_name
                });
              }, 300);
              return false;
            } else {
              switchAccountLoadingDialog = await window?.epPlatform?.showSwitchAccountLoading({
                closed: false,
                maskClose: false,
              });
            }
          },
          onClose: () => {},
          onSwitchSuccess: (info) => {

            switchAccountLoadingDialog && switchAccountLoadingDialog.closeModal();
            setTimeout(() => onSwitchSuccess?.(info), 300);
          },
          onSwitchFail: () => {
            switchAccountLoadingDialog && switchAccountLoadingDialog.closeModal();
            window?.epPlatform?.showSwitchAccountFail({
              closed: false,
              maskClose: false,
            });
            setTimeout(() => {
              window?.epPlatform.multiAccountApi.goLoginAccountPage({
                cb: location.href,
                autologin: false,
              });
            }, 2000);
          }
        });
      }

      result = limitStatus || switchStatus;
    } catch (e) {
      console.error(e);
      // 默认是关闭
      result = false;
    }
  });

  return result;
};

export const companyStart = async (companyid, userid, param) => {
  const url = 'https://plus.wps.cn/register?utm_source=WPS365_EDU_WEB&utm_medium=navigation&utm_buysource=edu'
  try {
    const openStatus = await openRegisterMultiAccountGuide({
      companyid,
      userid,
      closed: true,
      onSwitchSuccess: () => location.reload(),
    });
  
    // 超限弹窗或多账号弹窗是开启的，则不进行跳转
    if (!openStatus) {
      window.open(url)
    }
  } catch(e) {
    window.open(url)
  }
}